import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as esriLoader from 'esri-loader';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from 'material-ui/CircularProgress';
import SummariesList from './SummariesList';
import theme from '../../muiTheme';
import './ReportingDialog.css';
import { filterOperations } from '../../redux/filter';
import { history } from '../../index';
import { getMapExtent } from '../esri/mapHub';

const styles = makeStyles(theme => ({
  root: {
   flexGrow: 1,
 },
 menuButton: {
   marginRight: theme.spacing(2),
 },
 heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  }
}));

class ReportingDialog extends Component {

  constructor (props) {
    super(props);

    this.child = React.createRef();

    this.state = {
      selectedSummaries: [],
      incidents: [],
      dataLoaded: false,
      isLoading: false,
      userMenuOpen: false,
      anchorEl: null
    }

    this.menuIconRefElement = null;

    this.setMenuIconInputRef = element =>
    {
        this.menuIconRefElement = element;
    };
  }
  
  componentWillReceiveProps(nextProps)
  {
    esriLoader.loadModules(['esri/geometry/support/webMercatorUtils'])
    .then( ([WebMercatorUtils]) =>
    {
    if (!this.state.isLoading && !this.state.dataLoaded) 
      {
      this.setState({
        isLoading: true
      });

        var geographicExtent = WebMercatorUtils.webMercatorToGeographic(nextProps.extent);
        window.api.getIncidentDataForSummaries(geographicExtent, nextProps.definitionExpression).then((incidents) => 
        {
          console.log("ReportingDialog found " + incidents.length); 
          this.setState({
            incidents: incidents,
            dataLoaded: true,
            isLoading: false
          });
        }); 
    }
  }); 
  }

  handleCheckboxChange = (name) => event =>
  {
    let summaries = this.state.selectedSummaries;

    if (event.target.checked)
    {
        if (this.state.selectedSummaries.includes(event.target.value))
            return;

        summaries.push(event.target.value);
        this.setState({
          selectedSummaries: summaries
        });
    }
    else
    {
      if (!this.state.selectedSummaries.includes(event.target.value))
          return;

      let newSummaries = summaries.filter(summary => summary !== event.target.value);
      this.setState({
        selectedSummaries: newSummaries
      });
    }
  };

generateFilterList = () => {

let shouldRender = (this.state.selectedSummaries.length > 0 && (this.state.incidents.length > 0) && this.state.dataLoaded === true);

//TODO: Rework this
let filterNodes = [];
filterNodes.push(<h2 key="ActiveFiler">Active Filters</h2>);
/*
visible: true,
loading: true,
useExtent: true,
geometry: null,
discoveryDateMax: null,
discoveryDateMin: new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0),
outDateMax: null,
outDateMin: null,
modifiedDateMax: null,
modifiedDateMin: null,
fireAcresMax: null,
fireAcresMin: null,
originWhereClause: null,
structuresDestroyed: null,
injuries: null,
fatalities: null,
certified: null,
reportSearchTerms: null,
landownerCategories: [],
incidentJurisdictionalAgency: null,
jurisdictionalUnit: null,
jurisdictionalUnitParentUnit: null,
uniqueFireIds: [],
activeDrawTool: null,
modifiedBySystem: null
*/
  if (this.props.filter.gacc !== null)
  {
    filterNodes.push(<div><b>GACC:</b> {this.props.filter.gacc}</div>);
  }

  if (this.props.filter.fireCauses !== null && this.props.filter.fireCauses.length > 0)
  {
    filterNodes.push(<div><b>Fire Causes:</b> {this.props.filter.fireCauses.join(", ")}</div>);
  }

  if (this.props.filter.categories !== null && this.props.filter.categories.length > 0)
  {
    filterNodes.push(<div><b>Incident Type:</b> {this.props.filter.categories.join(", ")}</div>);
  }

  if (this.props.filter.state !== null)
  {
    filterNodes.push(<div><b>State:</b> {this.props.filter.state}</div>);
  }

  if (this.props.filter.county !== null)
  {
    filterNodes.push(<div><b>County:</b> {this.props.filter.county}</div>);
  }

  if (this.props.filter.strategies !== null && this.props.filter.strategies.length > 0)
  {
    filterNodes.push(<div><b>Initial Fire Strategies:</b> {this.props.filter.strategies.join(", ")}</div>);
  }

  if (this.props.filter.landownerCategories !== null && this.props.filter.landownerCategories.length > 0)
  {
    filterNodes.push(<div><b>Landowner Categories:</b> {this.props.filter.landownerCategories.join(", ")}</div>);
  }

  if (this.props.filter.fireAcresMin !== null || this.props.filter.fireAcresMax !== null)
  {
    filterNodes.push(<div><b>Fire Acres:</b> Min: {this.props.filter.fireAcresMin}  Max: {this.props.filter.fireAcresMax}</div>);
  }

  return filterNodes;
}

userMenuClick = (event) => {
  event.preventDefault();

  this.setState({
    userMenuOpen: true,
    anchorEl: event.currentTarget,
  });
};

downloadCsv = ()  =>
{
  this.child.current.downloadCsv();
}


handleClose = ()  => {
  this.setState({
    userMenuOpen: false,
    anchorEl: null,
  });
}

  handleGenerateSummaries = () =>
  {
      this.setState({
        isLoading: true
      });

      let currentIncidents = this.props.scopedIncidents;

      this.setState({
        dataLoaded: true,
        incidents: currentIncidents,
        isLoading: false
      });
  }

  render() {

    const loadingSpinner = (this.state.isLoading) ? (  <CircularProgress size={24} thickness={2} color={theme.palette.primary1Color} />) : "";
    const actions = [
      <FlatButton
        label="Print"
        className="reporting-print-btn"
        primary={false}
        disabled={this.state.selectedSummaries.length === 0 || !this.state.dataLoaded}
        onClick={() => {

        history.push({
              pathname: '/reporting/print',
              state:
              {
                incidents: this.state.incidents,
                summaries: this.state.selectedSummaries,
                extent: this.props.extent,
                definitionExpression: this.props.definitionExpression,
                screenshot: this.props.screenshot
              }
            });
        }
      }
      />,
      <FlatButton
        label="Export"
        className="reporting-print-btn"
        onClick={this.downloadCsv}
        disabled={this.state.selectedSummaries.length === 0 || !this.state.dataLoaded}
      />,
      <FlatButton
        label="Close"
        className="reporting-print-btn"
        primary={true}
        onClick={this.props.onClose}
      />
    ];

    return (
      <Dialog
        open={true}
        actions={actions}
        modal={true}
        autoScrollBodyContent={true}
        contentStyle={{width: '80%', height:'70%', maxWidth: 'none', overflowy: 'auto'}}
        className="dialog-modal"
        >
        <AppBar position="static" className="no-print-column">
           <Toolbar variant="dense" className="no-print-column">
             <Typography variant="h6" color="inherit" className="no-print-column">
               Reporting
             </Typography>
         </Toolbar>
       </AppBar>

       <Paper>
       <div className="row">
          <div className="no-print-column">
            <h2 ref={this.setMenuIconInputRef}>Available Summaries</h2>
            <List className={styles.root}>
            {['County','Fire Cause','Fire Cause General','Jurisdictional Agency','Jurisdictional Unit', 'Protecting Unit', 'Protecting Agency', 'Incident Category','Landowner Category', 'Size Class', 'State'].map(value => {
              const labelId = `checkbox-list-label-${value}`;
              return (
                <ListItem key={value} role={undefined} dense button>
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      value={value}
                      tabIndex={-1}
                      onChange={this.handleCheckboxChange(value)}
                      disableRipple
                      inputProps={{ 'aria-labelledby': labelId }}
                    />
                  </ListItemIcon>
                  <ListItemText id={labelId} primary={value} />
                </ListItem>
              );
            })}
          </List>
          <FlatButton
            label="Create Summaries"
            primary={true}
            onClick={this.handleGenerateSummaries}
            disabled={this.state.selectedSummaries.length === 0 || this.state.queryingForIncidents}
          />{loadingSpinner}
          </div>
          <div className="print-column">
          <div className="report-page">
          { this.generateFilterList() }
          </div>
          <SummariesList
            ref={this.child}
            key="SummariesList"
            summaries={this.state.selectedSummaries}
            incidents={this.state.incidents}
            definitionExpression={this.props.definitionExpression}
            extent={this.props.extent}
            screenshot={this.props.screenshot}
          />
          </div>
        </div>
        </Paper>
      </Dialog>
    )
  }
}

const mapStateToProps = state => ({
  appConfig: state.config,
  filter: state.filter
})


const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
      ...filterOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportingDialog)
